// routes.js
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginApp from './containers/LoginApp';

const Routes = () => (
  <Switch>
    <Route path="/login" component={LoginApp} />
  </Switch>
);

export default Routes;
